import { updateRecord, updateRecordDelete } from '../../shared/helpers/utils';
import { SET_ACCOUNT, SET_BANK_DELETE, SET_UPDATE_BANK_ACCOUNT } from './actionTypes';

const initialState = {
    bankAccounts: []
};

const profile = (state = initialState, action) => {
    switch (action.type) {
        case SET_BANK_DELETE:
            const newBankAccounts = updateRecordDelete(action.payload, state.bankAccounts);

            state = { ...state, bankAccounts: newBankAccounts };
            break;
        case SET_UPDATE_BANK_ACCOUNT:
            const bankAccounts = updateRecord(action.payload.id, action.payload, state.bankAccounts, 'primaryAccount');

            state = { ...state, bankAccounts };
            break;
        case SET_ACCOUNT:
            state = { ...state, bankAccounts: action.payload };
            break;

        default:
            state = { ...state };
            break;
    }
    return state;
};

export default profile;
